import { render, staticRenderFns } from "./productFieldsInPR.vue?vue&type=template&id=b248c4e8&"
import script from "./productFieldsInPR.vue?vue&type=script&lang=js&"
export * from "./productFieldsInPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports